import { IUnitsRepository } from 'shared/domain/repositories';
import { TLocale } from 'shared/domain/valueObjects';
import { makeHTTPProvider } from 'shared/infra/providers';

import VectisUnitsRepository from './implementations/VectisUnitsRepository';

let instance: IUnitsRepository | null = null;

interface IParams {
  language?: TLocale;
}

export default function makeUnitsRepository(params: IParams) {
  if (!instance) {
    const httpProvider = makeHTTPProvider(params);

    instance = new VectisUnitsRepository(httpProvider);
  }

  return instance;
}
